import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const PrintQuestionPaper = ({ printContent }) => {
  const printQuestionPaperRef = useRef(null);

  const modifiedPrintContent = printContent.replace(
    /<button class="delete-button">.*?<\/button>/g,
    ""
  );

  useEffect(() => {
    const printButton = document.querySelector(".print-button");
    

    const handlePrint = (e) => {
      e.preventDefault(); // Prevent default button behavior
      console.log("Print button clicked");
      const printContent = printQuestionPaperRef.current.innerHTML;
      const originalDocument = document.body.innerHTML;
      document.body.innerHTML = printContent;

      window.print();

      document.body.innerHTML = originalDocument;
    };

    if (printButton) {
      printButton.innerText =' Print Question Paper'
    }
    if (printButton) {
      printButton.addEventListener("click", handlePrint);
    }

    return () => {
      if (printButton) {
        printButton.removeEventListener("click", handlePrint);
      }
    };
  }, []);
  return (
    <div className="mx-auto px-5 max-w-[1000px]  ">
      <Link to="/">
      <button className=" bg-blue-500 mx-3 my-2 text-white py-2 px-4 rounded mt-4 flex justify-center items-center w-full m-auto">
        Go Back to Home
      </button></Link>
      <div 
        ref={printQuestionPaperRef}
        dangerouslySetInnerHTML={{ __html: modifiedPrintContent }}
      />
      <style>
        {`
          @media print {
            body {
              background-color: #fff;
              color: #000;
            }

            /* Additional print-specific styles can be included here */
          }
        `}
      </style>
    </div>
  );
};

export default PrintQuestionPaper;
